import React from 'react';


const RawHTML = ({ children, ...props }) => (
  <div {...props} dangerouslySetInnerHTML={{ __html: children }}/>
);

export default RawHTML;